export var EPaymentServiceType;
(function (EPaymentServiceType) {
    EPaymentServiceType[EPaymentServiceType["TYPE_E"] = 0] = "TYPE_E";
    EPaymentServiceType[EPaymentServiceType["TYPE_CC"] = 5] = "TYPE_CC";
})(EPaymentServiceType || (EPaymentServiceType = {}));



//////////////////
// WEBPACK FOOTER
// ./src/models/interfaces/Payment/EPaymentServiceType.ts
// module id = J/VA
// module chunks = 18